import React, { Fragment } from "react";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import ControlledDialog from "../../../../components/ControlledDialog/ControlledDialog";
import { TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles(() => ({
  resize: {
    padding: 14,
  },
  label: {
    marginTop: 9,
    fontSize: 16,
    color: "#1558a2",
    fontWeight: 700,
    marginRight: 10,
  },
  actions: {
    marginTop: 20,
    display: "flex",
    justifyContent: "right",
  },
}));

const ChangeStatus = (props) => {
  const { handleClose, open, state, onHandleChange, onSaveClick } = props;
  const classes = useStyles();

  return (
    <Fragment>
      <ControlledDialog
        hideClose
        open={open}
        disableBackdropClick
        handleClose={() => handleClose()}
        title={
          <Fragment>
            <Tooltip title="Back">
              <IconButton onClick={() => handleClose()}>
                <ArrowBackIcon fontSize="small" color="primary" />
              </IconButton>
            </Tooltip>
            <span
              style={{
                fontSize: 18,
                color: "#1558a2",
                fontWeight: 700,
              }}
            >{`${state.selectedOrderId} || ${state.selectedProductName}`}</span>
          </Fragment>
        }
        content={
          <Fragment>
            <div>
              <span
                style={{
                  fontSize: 18,
                  color: "#1558a2",
                  fontWeight: 700,
                }}
              >
                {
                  {
                    1: "Are you sure you want to confirm?",
                    2: "Are you sure you want to cancel?",
                    3: "Are you sure you want to confirm all?",
                    4: "Are you sure you want to cancel all?",
                  }[state.actionTypeId]
                }
              </span>
              {/* <div className={classes.label}>Status</div>
                            <TextField
                                placeholder="Status"
                                variant="outlined"
                                fullWidth
                                name="status"
                                value={state.actionTypeId===1?"Confirm" :"Cancel"}
                                disabled
                                InputProps={{ classes: { input: classes.resize } }}
                            >

                            </TextField> */}
            </div>
            <br />
            <div>
              <TextField
                label="Remarks"
                variant="outlined"
                fullWidth
                name="remarks"
                error={state.remarksError}
                value={state.remarks}
                onChange={(e) => onHandleChange(e)}
                // InputProps={{ classes: { input: classes.resize } }}
                size="small"
              />
            </div>

            <div className={classes.actions}>
              <Button
                onClick={() => onSaveClick()}
                disabled={
                  state.onCancelItemStatusLoading ||
                  state.onDoneItemStatusLoading
                }
                variant="contained"
                color="primary"
              >
                {state.onCancelItemStatusLoading ||
                  state.onDoneItemStatusLoading ? (
                  <CircularProgress size={30} />
                ) : (
                  "Yes"
                )}
              </Button>
              <Button
                disabled={
                  state.onCancelItemStatusLoading ||
                  state.onDoneItemStatusLoading
                }
                style={{ marginLeft: 20 }}
                onClick={() => handleClose()}
                variant="contained"
              >
                No
              </Button>
            </div>
          </Fragment>
        }
      />
    </Fragment>
  );
};

ChangeStatus.propTypes = {
  handleClose: PropTypes.func,
  onSaveClick: PropTypes.func,
  onHandleChange: PropTypes.func,
  open: PropTypes.bool,
  state: PropTypes.object,
};

ChangeStatus.defaultProps = {
  handleClose: (fn) => fn,
  onSaveClick: (fn) => fn,
  onHandleChange: (fn) => fn,
  open: false,
  state: {},
};

export default ChangeStatus;
